import { render, staticRenderFns } from "./the-upload-logo.vue?vue&type=template&id=5b89167c&scoped=true&"
import script from "./the-upload-logo.vue?vue&type=script&lang=js&"
export * from "./the-upload-logo.vue?vue&type=script&lang=js&"
import style0 from "./the-upload-logo.vue?vue&type=style&index=0&id=5b89167c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b89167c",
  null
  
)

export default component.exports